<div class='se-search-footer-container' id='selection-container'>
    <div style='flex-grow:1'>
        <button mat-mini-fab *ngFor='let data of selectionMetaData' class='fab-selection-button fab-no-opacity'
                [matTooltip]='data.tooltip' matTooltipPosition='above' 
                (click)='selectionBtnClick(data)'>
            {{data.buttonContent}}
            <span class='badge' (click)='removeSelectionBtnClick($event, data)'>X</span>
        </button>
    </div>

    <button mat-icon-button *ngIf='selectionMetaData.length' class='se-button-config'
            matTooltip="{{'DeselectAll' | translate}}" matTooltipPosition='above'
             (click)='unselectAllBtnClick()'>
        <mat-icon>clear</mat-icon>
    </button>
    <mat-divider class='se-header-divider' [vertical]='true'></mat-divider>
    <p class='config-counter' matTooltip="{{'ResultGridSelection' | translate}}" matTooltipPosition='above'
       >
        {{selectionMetaData.length}} / {{items.length}}
    </p>
</div>
